import React from "react";
import { Form } from "react-bootstrap";

import classNames from "classnames";
import { capitalize } from "lodash";

import { displayFormAlert } from "@lib/utils";

import UmpireRating from "@Clubhouse/components/GameSummary/components/UmpireRating";
import { useGameSummaryContext } from "@Clubhouse/components/GameSummary/contexts/GameSummary";
import { umpireRatingOptions } from "@Clubhouse/components/GameSummary/lib/constants";

const UmpireInfo = (): React.JSX.Element => {
    const { game, umpireRatings, methods } = useGameSummaryContext();

    return (
        <section className="umpireDetails" data-testid="umpireDetails">
            <h3>Umpire Info</h3>
            <div>
                <div className="bg-body-primary heading">
                    {game.umpires
                        ? "* To rate an Umpire, please click on the appropriate star Rating"
                        : "No registered umpires"}
                </div>

                <div className="bg-body-secondary umpireInfo">
                    {Object.keys(umpireRatingOptions).map((location, idx) => {
                        const umpireInfo = game.umpires?.find(
                            u => u.location === location,
                        );
                        const ratedUmpire = umpireRatings.find(
                            r => r.umpire.id === umpireInfo?.id,
                        );

                        const watchComments = methods.watch(
                            `${location as keyof typeof umpireRatingOptions}.comments`,
                        );

                        return (
                            umpireInfo && (
                                <div className={`umpire ${location}`} key={idx}>
                                    <b>{capitalize(location)} Umpire</b>
                                    {umpireInfo.name}
                                    <br />
                                    <span>
                                        <a href={`mailto:${umpireInfo.email}`}>
                                            {umpireInfo.email}
                                        </a>
                                    </span>
                                    tel: {umpireInfo.phone}
                                    <UmpireRating
                                        location={
                                            location as keyof typeof umpireRatingOptions
                                        }
                                        umpire={umpireInfo}
                                        ratedUmpire={ratedUmpire}
                                    />
                                    <Form.Group
                                        className={classNames("umpireComments")}
                                    >
                                        {watchComments?.length === 500 &&
                                            displayFormAlert({
                                                level: "danger",
                                                text: "Comments are limited to 500 characters",
                                                settings: "mt-4 mb-0",
                                            })}
                                        <Form.Label>
                                            Comments for {umpireInfo.name}
                                        </Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            maxLength={500}
                                            {...methods.register(
                                                `${location as keyof typeof umpireRatingOptions}.comments`,
                                            )}
                                        />
                                    </Form.Group>
                                </div>
                            )
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default UmpireInfo;
